export const staffContext = {
    selectedSemester: '',
    semesters: [],
    selectedTerm: '',
    terms: [],
    staff: 0,
    groups: 0,
    tableHeader: 'Staff Progression Chart',
    tableColumn: ['Id', 'First Name', 'qualifications', 'department', 'position_id', 'rank_id', 'status_id'],
    tableData: [],
    tab: 0,
    load: 0,
    undergraduate: 0,
    postgraduate: 0,
    regular: 0,
    extension: 0,
    underload: 0,
    staffCount : 0,
    partimer : 0,
    fulltimer: 0,
    staffLoad : [13,15,19,10]
}